<div class="file-names">
  <div class="file" *ngFor="let projectFile of activity?.files; trackBy: trackEntityById">
    <div class="file-info-block">
      <div class="file-name" (click)="openFile(projectFile)">
        {{projectFile?.name}}
      </div>
    </div>

    <span class="delete-icon" (click)="deleteFile(projectFile)">
			<mat-icon>clear</mat-icon>
		</span>
  </div>
</div>

<mat-progress-bar *ngIf="progressBar > 0" mode="determinate" value="{{progressBar}}">
</mat-progress-bar>


<p-fileUpload mode="basic" name="files" #filesForm (onProgress)="onProgress($event)" [customUpload]="true"
              (uploadHandler)="uploadFile($event.files, filesForm)" [auto]="true" [multiple]="true"
              chooseLabel="Upload">
</p-fileUpload>
